import * as Yup from 'yup';

export const initialValues = {
  reasonReject: '',
};

export const validationSchema = Yup.object().shape({
  reasonReject: Yup.string().required().min(5).max(200),
});
